module.exports = __webpack_public_path__ + "static/media/nham24_logo.2b25ff80.png";